/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { omit } from "lodash";

import { Block as PrismaBlock } from "@vienna/prisma";

import { ILLEGAL_BLOCK_FIELDS, READ_ONLY_CLIENT_BLOCK_FIELDS } from "../constants";
import { Block } from "../entities/block.entity";

/**
 * Remove block fields that are not allowed to be sent to the client
 *
 * @returns - the filtered block as Partial<Block>
 */
export const pruneClientOnlyBlockFields = (block: Partial<Block>): Partial<PrismaBlock> => {
  const omittedBlock = omit(block, [...ILLEGAL_BLOCK_FIELDS, ...READ_ONLY_CLIENT_BLOCK_FIELDS]);
  return omittedBlock as Partial<PrismaBlock>;
};
